




























































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getIndexFromList,
    goToUrl
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Combobox from '../../core/components/Combobox.vue';
import { MsgBox, PlusEyeButtons, Breadcrums, CloseConfirmationModal } from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import { getUrlRanchDetail, getUrlRanchSowingDetail } from '../utils';
import { farmingRanchesConfig, linkRanchsConfig } from '../api/models';
import { HarvestRanchEditableFields } from '../ranch';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        PlusEyeButtons,
        Breadcrums,
        CloseConfirmationModal
    }
})
export default class ModalLinkRanchs extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    ranchsOptions: Array<object> = [];
    @Prop() visible: boolean;
    @Prop({default: null}) selectedRanch: object;
    @Prop({default: false}) isSowing: boolean;
    @Prop({default: -1}) farmingId: number;
    @Prop({default: null}) currentRanchLink: object | null;
    visibleModalLinkRanchs: boolean = false;
    pendingRequest: boolean = false;
    description: string = '';
    modalTitle: string = '';
    sowingTitle: string = 'con Chacra de Siembra';
    harvestTitle: string = 'con Chacra de Cosecha';
    saveBtn: string = 'Vincular Chacras';
    alternativeMsg: string = 'Chacras vinculadas con éxito';
    alternativeMsgError: string = 'No se pudieron vincular las chacras'
    ranchSelected: object | null = null;
    ranchSelectedRV: boolean = false;
    pendingOptions: boolean = false;

    seeRanch(){
        if(this.ranchSelected){
            let seeRanchUrl = this.isSowing ? getUrlRanchDetail(this.ranchSelected['id']) : getUrlRanchSowingDetail(this.ranchSelected['id']);
            goToUrl(seeRanchUrl);
        }
        
    }

    mounted() {
        this.handleListenKey(true);
        this.setModalTitle();
        this.visibleModalLinkRanchs = this.visible;
        this.getRanchsOptions();
    }

    getRanchsOptions(){
        this.pendingOptions = true;
        let config:farmingRanchesConfig = {
            id: this.farmingId,
            ranch_type: this.isSowing ? 0 : 1
        }
        InsuranceServices.getRanchsByFarmingIdAndType(
            config
        ).then((res) => {
            this.ranchsOptions = res;
            this.preselectCurrentRanchLink();
            this.pendingOptions = false;
        }).catch(error => {
            this.pendingOptions = false;
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'No se pudo traer el listado de chacras'
            })
        });
    }

    setModalTitle(){
        let baseTitle = 'Vincular ' + this.selectedRanch['name'] + ' ';
        if(this.isSowing){
            this.modalTitle = baseTitle += this.harvestTitle
        }else{
            this.modalTitle = baseTitle += this.sowingTitle
        }
    }

    preselectCurrentRanchLink(){
        if(this.currentRanchLink !== null){
            let indexRanchInSowingOptions = getIndexFromList(this.ranchsOptions, 'id', this.currentRanchLink['id']);
            if(indexRanchInSowingOptions !== -1){
                this.updateRanchSelected(this.ranchsOptions[indexRanchInSowingOptions])
            }
        }
    }

    @Emit()
    addNewLinkToRanch(sowing_ranch_link, harvestRanchId){}

    @Emit()
    updateEditableFields(editableFields: HarvestRanchEditableFields){}


    updateRanchSelected(option) {
        this.ranchSelected = option;
    }

    updateRanchSelectedRV(value) {
        this.ranchSelectedRV = value;
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.handleListenKey(false);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    linkWithHarvestRanch(data){
        // console.log("linkWithHarvestRanch");
        InsuranceServices.linkSowingRanchWithHarvestRanch(
            data
        ).then(response => {
           this.successLink(response);
        })
        .catch(err => {
            this.failedLink(err);
        });
    }

    successLink(response){
        this.pendingRequest = false;
        this.showSuccessLoadingDialog(response, this.alternativeMsg);
        this.updateLinkInRanchsList();
    }

    failedLink(err){
        this.pendingRequest = false;
        this.showCatchLoadingDialog(err, this.alternativeMsgError);
    }

    updateLinkInRanchsList(){
        let sowing_ranch_link = this.ranchSelected;
        this.addNewLinkToRanch(sowing_ranch_link, this.selectedRanch['id'])
    }

    linkWithSowingRanch(data){
        InsuranceServices.linkHarvestRanchWithSowingRanch(
            data
        ).then(response => {
           this.successLink(response);
           if(response && response.editable_fields){
            this.updateEditableFields(response.editable_fields);
           }
        })
        .catch(err => {
            this.failedLink(err);
        });
    }

    triggerSubmit() {
        let self = this;
        this.pendingRequest = true;
        let configuration = this.getData();
        this.showLoadingDialog('Vinculando Chacras...');

        if(this.isSowing){
            this.linkWithHarvestRanch(configuration)
        }else{
            this.linkWithSowingRanch(configuration);
        }
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }

    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }

    getData():linkRanchsConfig {
        return {
            ranch_id: Number(this.selectedRanch['id']), //id  chacra actual,
            link_to: this.ranchSelected !== null ? this.ranchSelected['id'] : -1 //id chacra para vincular
        };
    }

    get checkIfFormIsValid() {
        if (this.ranchSelected == null) {
            return false;
        }
        return true;
    }


    closeModalLoadingDialog() {
       
    }
}
